// extracted by mini-css-extract-plugin
module.exports = {"button-with-tooltip":"EditButton_button-with-tooltip__1vYD1","container":"EditButton_container__1ONwT"};